/** @format */
import angular from 'angular';
import _ from 'lodash';
import { UuidService } from 'sis-common';
import { BasicGroupingPanelComponent } from '../grouping-panel/basic-grouping-panel.component';
import { percentEditorModule } from '../number/percentEditor.dir';
import { CodeSelectEditorComponent } from '../select/code-select-editor.component';
import currentOrganisationRoleShareEditorTpl from './currentOrganisationRoleShareEditor.tpl.html';
import { searchOrganisationModule } from './searchOrganisation.comp';

export const currentOrganisationRoleShareEditorModule = 'sis-components.organisation.current-organisation-role-share-editor';

(function () {
    currentOrganisationRoleShareEditorController.$inject = ['commonOrganisationService', 'uuidService'];
    angular
        .module(currentOrganisationRoleShareEditorModule, [
            'pascalprecht.translate',
            percentEditorModule,
            searchOrganisationModule,
            'sis-components.service.organisationService',
            CodeSelectEditorComponent.downgrade.moduleName,
            UuidService.downgrade.moduleName,
            BasicGroupingPanelComponent.downgrade.moduleName,
        ])
        .component('currentOrganisationRoleShareEditor', {
            bindings: {
                organisationRoleShares: '<',
                save: '&?',
                onChange: '&',
                showResetButton: '<',
                reset: '&',
                hideButtons: '<?',
                validationErrors: '=?',
                roleUrn: '<',
            },
            controller: currentOrganisationRoleShareEditorController,
            template: currentOrganisationRoleShareEditorTpl,
        });

    function currentOrganisationRoleShareEditorController(commonOrganisationService, uuidService) {
        const $ctrl = this;
        $ctrl.organisationService = commonOrganisationService;

        $ctrl.$onInit = function () {
            setSelectedOrganisationIds();
            setSelectedEducationalInstitutions();
            $ctrl.validationErrors = _.isUndefined($ctrl.validationErrors) ? {} : $ctrl.validationErrors;
        };

        $ctrl.getOrganisationRoleSharesByRoleUrn = function () {
            return _.filter($ctrl.organisationRoleShares, { roleUrn: $ctrl.roleUrn });
        };

        $ctrl.saveOrganisationRoleShares = function () {
            $ctrl.save({ organisationRoleShares: $ctrl.organisationRoleShares });
        };

        $ctrl.resetOrganisationRoleShares = function () {
            $ctrl.reset();
            $ctrl.onChange({ organisationRoleShares: $ctrl.organisationRoleShares });
        };

        $ctrl.changeOrganisationRoleShare = function () {
            $ctrl.onChange({ organisationRoleShares: $ctrl.organisationRoleShares });
        };

        $ctrl.addNewOrganisationRoleShare = function () {
            $ctrl.organisationRoleShares.push({ _id: uuidService.randomUUID(), share: 1.0, roleUrn: $ctrl.roleUrn, validityPeriod: {} });
            $ctrl.onChange({ organisationRoleShares: $ctrl.organisationRoleShares });
        };

        $ctrl.selectOrganisation = function (organisationRoleShare, orgObj) {
            delete organisationRoleShare.organisationId;
            organisationRoleShare.organisation = orgObj;
            if (_.get(orgObj, 'id')) {
                organisationRoleShare.organisationId = orgObj.id;
            }
            setSelectedOrganisationIds();
            $ctrl.onChange({ organisationRoleShares: $ctrl.organisationRoleShares });
        };

        $ctrl.setSelectedEducationalInstitutionUrn = function (organisationRoleShare, selectedUrn) {
            organisationRoleShare.educationalInstitutionUrn = selectedUrn;
            setSelectedEducationalInstitutions();
            $ctrl.onChange({ organisationRoleShares: $ctrl.organisationRoleShares });
        };

        $ctrl.removeOrganisationRoleShare = function (organisationRoleShare) {
            _.pull($ctrl.organisationRoleShares, organisationRoleShare);

            setSelectedOrganisationIds();
            setSelectedEducationalInstitutions();
            $ctrl.onChange({ organisationRoleShares: $ctrl.organisationRoleShares });
        };

        function setSelectedOrganisationIds() {
            $ctrl.selectedOrganisationIds = _.compact(_.map($ctrl.getOrganisationRoleSharesByRoleUrn(), 'organisationId'));
        }

        function setSelectedEducationalInstitutions() {
            const institutions = _.map($ctrl.getOrganisationRoleSharesByRoleUrn(), 'educationalInstitutionUrn');
            $ctrl.excludedEducationalInstitutions = _.compact(institutions);
        }

        $ctrl.isCoordinatingOrganisation = function () {
            return this.roleUrn === 'urn:code:organisation-role:coordinating-organisation';
        };

        $ctrl.isResponsibleOrganisation = function () {
            return this.roleUrn === 'urn:code:organisation-role:responsible-organisation';
        };

        $ctrl.getOrganisationsTranslationKey = function () {
            if ($ctrl.isResponsibleOrganisation()) {
                return 'SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_EDITOR.RESPONSIBLE_ORGANISATIONS';
            }
            if ($ctrl.isCoordinatingOrganisation()) {
                return 'SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_EDITOR.COORDINATING_ORGANISATIONS';
            }
            return '';
        };

        $ctrl.getAddTranslationKey = function () {
            if ($ctrl.isResponsibleOrganisation()) {
                return 'SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.ADD_ORGANISATION';
            }
            if ($ctrl.isCoordinatingOrganisation()) {
                return 'SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.ADD_ORGANISATION_OR_EDUCATIONAL_INSTITUTION';
            }
            return '';
        };

        $ctrl.isResponsibleOrganisationMissing = function () {
            if (!$ctrl.isResponsibleOrganisation()) {
                $ctrl.validationErrors.isResponsibleOrganisationMissing = false;
            } else {
                $ctrl.validationErrors.isResponsibleOrganisationMissing = !_.some($ctrl.getOrganisationRoleSharesByRoleUrn(), {
                    roleUrn: $ctrl.roleUrn,
                });
            }
            return $ctrl.validationErrors.isResponsibleOrganisationMissing;
        };

        $ctrl.isOrganisationMissing = function () {
            if ($ctrl.isCoordinatingOrganisation()) {
                $ctrl.validationErrors.isOrganisationMissing = false;
            } else {
                $ctrl.validationErrors.isOrganisationMissing = !_.isNil(
                    _.find($ctrl.getOrganisationRoleSharesByRoleUrn(), organisationRoleShare =>
                        _.isNil(organisationRoleShare.organisation),
                    ),
                );
            }
            return $ctrl.validationErrors.isOrganisationMissing;
        };

        $ctrl.isOrganisationAndEducationalInstitutionMissing = function () {
            if (!$ctrl.isCoordinatingOrganisation()) {
                $ctrl.validationErrors.isOrganisationAndEducationalInstitutionMissing = false;
            } else {
                $ctrl.validationErrors.isOrganisationAndEducationalInstitutionMissing = !_.isNil(
                    _.find(
                        $ctrl.getOrganisationRoleSharesByRoleUrn(),
                        organisationRoleShare =>
                            _.isNil(organisationRoleShare.organisation) && _.isNil(organisationRoleShare.educationalInstitutionUrn),
                    ),
                );
            }
            return $ctrl.validationErrors.isOrganisationAndEducationalInstitutionMissing;
        };

        $ctrl.isOrganisationAndEducationalInstitutionDefined = function () {
            if (!$ctrl.isCoordinatingOrganisation()) {
                $ctrl.validationErrors.isOrganisationAndEducationalInstitutionDefined = false;
            } else {
                $ctrl.validationErrors.isOrganisationAndEducationalInstitutionDefined = !_.isNil(
                    _.find(
                        $ctrl.getOrganisationRoleSharesByRoleUrn(),
                        organisationRoleShare =>
                            !_.isNil(organisationRoleShare.organisation) && !_.isNil(organisationRoleShare.educationalInstitutionUrn),
                    ),
                );
            }
            return $ctrl.validationErrors.isOrganisationAndEducationalInstitutionDefined;
        };

        //Using delta of 10^-7 (selected arbitrarily) to check that absolute value of shareSum - 1 is larger than
        //delta. Original check was shareSum !== 1 that failed with 0.7, 0.2, 0.1.
        $ctrl.isRoleShareTotalInvalid = function () {
            if (_.isUndefined($ctrl.getOrganisationRoleSharesByRoleUrn()) || _.isEmpty($ctrl.getOrganisationRoleSharesByRoleUrn())) {
                $ctrl.validationErrors.isRoleShareTotalInvalid = false;
            } else {
                var shareSum = _.reduce(
                    $ctrl.getOrganisationRoleSharesByRoleUrn(),
                    function (sum, organisation) {
                        return sum + organisation.share;
                    },
                    0,
                );
                $ctrl.validationErrors.isRoleShareTotalInvalid = Math.abs(shareSum - 1) >= 0.0000001;
            }
            return $ctrl.validationErrors.isRoleShareTotalInvalid;
        };

        $ctrl.someRoleSharesAreNotPositive = function () {
            if (_.isUndefined($ctrl.getOrganisationRoleSharesByRoleUrn()) || _.isEmpty($ctrl.getOrganisationRoleSharesByRoleUrn())) {
                $ctrl.validationErrors.someRoleSharesAreNotPositive = false;
            } else {
                $ctrl.validationErrors.someRoleSharesAreNotPositive = !_.every(
                    $ctrl.getOrganisationRoleSharesByRoleUrn(),
                    function (organisationRoleShare) {
                        return organisationRoleShare.share > 0;
                    },
                );
            }
            return $ctrl.validationErrors.someRoleSharesAreNotPositive;
        };
    }
})();
